import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LangProvider } from "@/i18n/LangContext";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Products from "@/components/site/Products";
import Technology from "@/components/site/Technology";
import PdlcTechnology from "@/components/site/PdlcTechnology";
import Applications from "@/components/site/Applications";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import FAQPage from "@/components/site/FAQPage";

function Landing() {
  return (
    <div data-testid="landing-page" className="bg-[#FAFAFA] text-[#1D1D1F]">
      <Navbar />
      <main>
        <Hero />
        <Products />
        <Technology />
        <PdlcTechnology />
        <Applications />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function FAQRoute() {
  return (
    <div className="bg-[#FAFAFA] text-[#1D1D1F]">
      <Navbar />
      <FAQPage />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <LangProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/faq" element={<FAQRoute />} />
            </Routes>
          </BrowserRouter>
        </LangProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
